<template>
  <section class="section_dethi">

    <div class="ss-breadcrumb">
      <div class="container-hts">
        <ul class="margin-0 p-0">
          <li><router-link :to="{name: 'ebook'}"><i class="fas fa-chevron-left font-size-14"></i>  Sách điện tử</router-link></li>
        </ul>
      </div>
    </div>
    <div class="ss-head">
      <div class="container-hts">
        <h1 class="ss-head__title font-size-24 primary-color-txt font-sanpro-semibold">{{ ebooksType.bookGroup.name }}</h1>
        <p class="ss-head__desc primary-color-txt">{{ ebooksType.bookType.name }}</p>
      </div>
    </div>
    <div class="ss-data list__box__body list__box__body--grid">
      <div class="container-hts box_content">
        <div class="row">
          <div class="item col-xl-3 col-lg-4 col-md-4 col-sm-6" v-for="(itemBook, index2) in ebooksType.books" :key="index2">
            <div class="item__wrap position-rel text-center">
              <div class="item__head">
                <router-link :to="{ name: 'ebook-detail', params: { id: itemBook.bookId, slug: itemBook.slug } }">
                  <img class="inner-img" :src="itemBook.imageUrl!=null?cdnUrl +itemBook.imageUrl.replace('Content//images','images'):''" :alt="itemBook.name" />
                </router-link>
              </div>
              <div class="item__body">
                <h3 class="item__name font-size-18 font-sanpro-semibold primary-color-txt">
                  <router-link :to="{ name: 'ebook-detail', params: { id: itemBook.bookId, slug: itemBook.slug } }" class="primary-color-txt">
                    {{ itemBook.name }}
                  </router-link>
                </h3>
                <p class="margin-0 secondary-color-txt font-size-14">Năm xuất bản: {{ itemBook.editionYear }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

  import {mapGetters, mapActions} from 'vuex';
  import {STORE_KEY, LOCAL_SAVE_BOOK_TYPE} from '../_store/constants'
  import store from '../_store'
  import EBookFilter from './EBookFilter'

  import { APP_CONFIG } from '@/utils/constants'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import 'swiper/dist/css/swiper.css'

const books=[]
export default {
  name: 'EBookType',
  components: {
    EBookFilter,
   swiper, 
   swiperSlide
  },
  data() {
    return {
      filterType: 0,
      typeId: this.$route.params.typeId,      
      classId: this.$route.params.classId,      
      groupId: this.$route.params.groupId,
      cdnUrl: APP_CONFIG.cdnUrl,
      nameBookType: ''
    }
  },
  props: {
  },
  computed: {
    ...mapGetters({
      ebooksType: STORE_KEY + '/ebooksType',
            filterObj: STORE_KEY + '/ebooksFilter',
    }),
  },
  mounted() {
//    var params={
//      book_type: this.id,
//      classes: [],
//      levels : [],
//      subjects : []
//    }
    // this.filterObj={};
    // this.filterObj['book_type']=[this.id];
    this.getBookTypeNamesaved()
   var params={
     book_type: [],
     classes: [],
     levels : [],
     subjects : [],
     bookGroupId: this.groupId
   }
   params.book_type.push(this.typeId);
   params.classes.push(this.classId);
    this.$store.dispatch(STORE_KEY + '/getEBooksType',params);
  },
  methods:{
    getBookTypeNamesaved() {
      this.nameBookType = localStorage.getItem(LOCAL_SAVE_BOOK_TYPE);
    },
    thumbUrl(filename) {
      return require(`@/assets/img/${filename}`);
    },
    viewAll(type){
      this.filterType= type;
    },
    getTypeId(){
      return parseInt(this.typeId);
    },
    filterBooks(filterData){
      // console.log("filterBooks")
      // console.log(filterData);
      this.$store.dispatch(STORE_KEY + '/getEBooksType',filterData);
    }
  }
}
</script>
<style lang="scss" scoped>
  .ss-head {
    padding: 20px 0 0;
  }
</style>